import { simplifyFileTypes } from "@/shared/components/custom/file-upload";
import {
  AGENT_TYPES,
  GapAssessmentTypes,
  RiskAssessmentTypes,
} from "../../types";

const DEFAULT_ALLOWED_FILE_TYPES = simplifyFileTypes([]).map(
	(key: string) => key,
);

export const helper = {
	[AGENT_TYPES.QUESTIONNAIRE]: {
		title: "Auto-populate a Security Questionnaire",
		desc: "Zania will refer to previous questionnaires filled by you and auto-fill a new questionnaire in seconds!",
		inputs: [
			{
				label: "Session Title",
				placeholder: "Add title",
				type: "text",
				key: "title",
				isRequired: true,
			},
			{
				label: "Customer Name",
				placeholder: "Add customer name",
				type: "text",
				key: "customer_name",
				isRequired: true,
			},
		],
		uploads: [
			{
				title: "Upload Questionnaire",
				allowedFileTypes: [
					"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
					"application/vnd.ms-excel",
				],
				maxFiles: 1,
				type: "main",
				isRequired: true,
        sec_ctx:'questionnaire-main'
			},
			{
				title: "Upload Knowledge Base",
				allowedFileTypes: DEFAULT_ALLOWED_FILE_TYPES,
				maxFiles: 30,
				type: "kb",
				isRequired: true,
        sec_ctx:'questionnaire-kb'
			},
		],
		dropdown: null,
		toggle: null,
	},
	[AGENT_TYPES.RISK_ASSESSMENT]: {
		title: "Conduct a Risk Assessment",
		desc: "Zania analyzes uploaded documents against the chosen framework, automatically assessing risks and identifying gaps.",
		inputs: [
			{
				label: "Session Title",
				placeholder: "Add title",
				type: "text",
				key: "title",
				isRequired: true,
			},
		],
		uploads: [
			{
				title: "Upload Evidences",
				allowedFileTypes: DEFAULT_ALLOWED_FILE_TYPES,
				maxFiles: 100,
				type: "main",
				isRequired: true,
        sec_ctx:AGENT_TYPES.RISK_ASSESSMENT
			},
		],
		dropdown: {
			label: "Framework",
			placeholder: "Select a framework",
			key: "framework",
			options: [
				{
					label: "FAIR",
					value: RiskAssessmentTypes.FAIR,
					isDefault: true,
				},
      ],
    },
    radio: null,
    toggle: null,
  },
  [AGENT_TYPES.GAP_ASSESSMENT]: {
    title: "Conduct Gap Assessment",
    desc: "Zania will compile evidences required to conduct gap assessment.",
    inputs: [],
    uploads: [
      {
        title: "Upload Evidences",
        allowedFileTypes: DEFAULT_ALLOWED_FILE_TYPES,
        maxFiles: 100,
        type: "main",
        isRequired: true,
        sec_ctx: AGENT_TYPES.GAP_ASSESSMENT
      },
    ],
    dropdown: {
      label: "Framework",
      placeholder: "Select a framework",
      key: "framework",
      options: [
        {
          label: "NIST CSF 2",
          value: RiskAssessmentTypes.NIST_CSF_2,
          isDefault: false,
        },
        {
          label: "NIST AI RMF",
          value: "nist_ai_rmf",
          isDefault: false,
        },
        {
          label: "SOC 2 Type I",
          value: GapAssessmentTypes.SOC2_TYPE1,
          isDefault: false,
        },
        {
          label: "SOC 2 Type II",
          value: GapAssessmentTypes.SOC2_TYPE2,
          isDefault: false,
        },
        {
          label: "Add New Framework",
          value: "add_new_framework",
          isDefault: false,
          isCustom: true,
        }
      ],
    },
    inputsAfterDropdown: [
      {
        label: "Session Title",
        placeholder: "Add title",
        type: "text",
        key: "title",
        isRequired: true,
      },
    ],
    radio: {
      label: "Evidences",
      key: "evidence_mapping",
      options: [
        {
          label: "View controls and upload separately",
          value: "customize",
          isDefault: true,
        },
        {
          label: "Upload all evidence at once",
          value: "all",
          isDefault: false,
        },
      ],
    },
    toggle: {
      label: "Customize Assessment",
    },
  },
  [AGENT_TYPES.MULTI_FILE_VENDOR_ASSESSMENT]: {
    title: "Conduct Third-Party Risk Assessment",
    desc: "Zania will use AI to conduct comprehensive vendor evaluations",
    inputs: [
      {
        label: "Third-Party",
        placeholder: "E.g.: Google",
        type: "vendorSearch",
        key: "vendorName",
        isRequired: true,
      },
      {
        label: "Product Name (Optional)",
        placeholder: "E.g.: Drive",
        type: "text",
        key: "productName",
        isRequired: false,
      }
    ],
    dropdown: {
      label: "Controls",
      placeholder: "Select a control set",
      key: "controlSet",
      options: [] // Will be populated from API
    },
    inputsAfterDropdown: [
      {
        label: "Request Vendor to Submit Details",
        placeholder: "Request Vendor to Submit Details",
        type: "toggle",
        key: "requestVendor",
        isRequired: false,
      }
    ],
    uploads: [],
    toggle: null, // Changed from {label: "Custom Controls"} to null
  },
  [AGENT_TYPES.POLICY_MANAGEMENT]: {
    title: "Manage Policies in Your Organization",
    desc: "Define or update policies and documentation for your organization.",
    inputs: [
      {
        label: "Session Title",
        placeholder: "Add title",
        type: "text",
        key: "title",
        isRequired: true,
      },
      {
        label: "Policy Name",
        placeholder: "Add policy name",
        type: "text",
        key: "policyName",
        isRequired: true,
      },
      {
        label: "Additional Instructions",
        placeholder: "Add Instructions",
        type: "textarea",
        key: "context",
        isRequired: true,
      }
    ],
    uploads: [
      {
        title: "Upload Knowledge Base (Optional)",
        allowedFileTypes: DEFAULT_ALLOWED_FILE_TYPES,
        maxFiles: 5,
        type: "kb",
        isRequired: false,
      },
    ],
    dropdown: {
      label: "Documentation Type",
      placeholder: "Select a documentation type",
      key: "docType",
      options: [
        {
          label: "Policy",
          value: "Policy",
          isDefault: true,
        },
        {
          label: "Procedure",
          value: "Procedure",
          isDefault: false,
        },
        {
          label: "Standard",
          value: "Standard",
          isDefault: false,
        },
        {
          label: "Guideline",
          value: "Guideline",
          isDefault: false,
        },
       
       
      ],
    },
    dropdown2: {
      label: "Choose an Action",
      placeholder: "Select an action",
      key: "action",
      options: [
        {
          label: "Create New ",
          value: "create_new",
          isDefault: true,
        },
        {
          label: "Update Existing",
          value: "update_existing",
          isDefault: false,
        },
      ],
    },
    toggle: null,
  },
};
